import { LoggedInUser } from '@libs/shared/interfaces/logged-in-user.interface';
import { createActionGroup, props } from '@ngrx/store';

export const AuthActions = createActionGroup({
  source: 'Auth',
  events: {
    'Set Logged In User': props<{ loggedInUser: LoggedInUser }>(),
  },
});
